module.exports = {"150825100":"巴音宝力格镇","150825101":"呼和温都尔镇","150825102":"潮格温都尔镇","150825200":"获各琦苏木","150825201":"巴音前达门苏木","150825202":"乌盖苏木"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150825.json
// module id = 464
// module chunks = 0